import { useRef, useContext } from "react";
import GVCompletionCard from "../components/GVCompletionCard";
import { GraphicalViewerContext } from "../../contexts/GraphicalViewerContext";

export default function GVCompletions() {

    const {
        completion,
    } = useContext(GraphicalViewerContext);

    const cardRef = useRef();
    if (!completion) return <></>;
    return (
        <>
            <div
                className="print"
                id={`completion-${completion.completion_id}`}
                key={completion.completion_id}
            >
                <div ref={cardRef} className="tableEl">
                    <GVCompletionCard />
                </div>
            </div>
        </>
    );
}
